import React from "react"
import Home from "views/Home"
import PlayAgain from "views/PlayAgain"
import Experience from "views/Experience"
import NotFound from "views/NotFound"
import ErrorPage from "views/ErrorPage"

import ProtectedRoute from "components/ProtectedRoute"

import { BrowserRouter as Router, Switch } from "react-router-dom"

import TagManager from "react-gtm-module"

const tagManagerArgs = {
  gtmId: "GTM-KG2MFS5",
}

TagManager.initialize(tagManagerArgs)

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <ProtectedRoute exact path="/" component={Home} />
          <ProtectedRoute exact path="/experience" component={Experience} />
          <ProtectedRoute exact path="/play-again" component={PlayAgain} />
          <ProtectedRoute exact path="/error" component={ErrorPage} />
          <ProtectedRoute path="/*" component={NotFound} />
        </Switch>
      </Router>
    </div>
  )
}

export default App
